// extracted by mini-css-extract-plugin
export default {"content":"content__content___1KlBN","content__heading":"content__content__heading___ji6ml"};